import { LegalPage, LegalH2 } from "@/components/LegalPage";
import { COMPANY } from "@/lib/company";

export default function DistanceSales() {
  return (
    <LegalPage title="Mesafeli Hizmet Satış Sözleşmesi" updated="18.08.2026" testid="distance-sales-page">
      <LegalH2>1. Taraflar</LegalH2>
      <p>
        İşbu Mesafeli Hizmet Satış Sözleşmesi (“Sözleşme”), aşağıda bilgileri bulunan taraflar arasında
        elektronik ortamda kurulmuştur.
      </p>
      <p>
        <b>ALICI</b><br />
        Ad / Soyad / Unvan: Sipariş sırasında ALICI tarafından bildirilen bilgiler<br />
        Adres: Sipariş sırasında ALICI tarafından bildirilen adres<br />
        Telefon: Sipariş sırasında ALICI tarafından bildirilen telefon<br />
        E-posta: Sipariş sırasında ALICI tarafından bildirilen e-posta adresi
      </p>
      <p>
        <b>SATICI / HİZMET SAĞLAYICI</b><br />
        Ad / Unvan: {COMPANY.owner} – İnce Fikirler Fotoğraf Prodüksiyon<br />
        Vergi Dairesi: Üsküdar Vergi Dairesi<br />
        Vergi No: {COMPANY.taxNo}<br />
        Adres: {COMPANY.address}<br />
        Telefon: {COMPANY.phone}<br />
        E-posta: {COMPANY.email}<br />
        İnternet Sitesi: https://studioai.incefikirler.tv/
      </p>
      <p>
        Bundan böyle SATICI / HİZMET SAĞLAYICI kısaca “SAĞLAYICI”, hizmet satın alan kişi ise “ALICI”
        olarak anılacaktır. ALICI, siparişi onaylaması halinde sipariş konusu hizmet bedelini, uygulanması
        halinde vergileri ve sipariş aşamasında açıkça belirtilen diğer ücretleri ödeme yükümlülüğü altına
        gireceği konusunda bilgilendirildiğini kabul eder. İşbu Sözleşmede tüketici haklarına ilişkin
        hükümler, ALICI'nın 6502 sayılı Tüketicinin Korunması Hakkında Kanun kapsamında “tüketici”
        sıfatına sahip olduğu işlemler bakımından uygulanır.
      </p>

      <LegalH2>2. Tanımlar</LegalH2>
      <p>
        İşbu Sözleşmenin uygulanmasında; <b>BAKANLIK</b>: T.C. Ticaret Bakanlığı'nı, <b>KANUN</b>: 6502
        sayılı Tüketicinin Korunması Hakkında Kanun'u, <b>YÖNETMELİK</b>: Mesafeli Sözleşmeler
        Yönetmeliği'ni, <b>HİZMET</b>: Bir ücret veya menfaat karşılığında gerçekleştirilen veya
        gerçekleştirilmesi taahhüt edilen; yapay zekâ destekli içerik üretimi, reklam filmi, tanıtım
        filmi, senaryo geliştirme, storyboard, görsel üretimi, video üretimi, kurgu, post-prodüksiyon ve
        teklif/sipariş kapsamında belirtilen diğer prodüksiyon hizmetlerini, <b>DİJİTAL İÇERİK</b>:
        Elektronik ortamda oluşturulan ve teslim edilen görsel, video, ses, metin, senaryo, tasarım ve
        benzeri dijital çıktıları, <b>SAĞLAYICI</b>: {COMPANY.owner} – İnce Fikirler Fotoğraf
        Prodüksiyon’u, <b>ALICI</b>: Hizmeti satın alan gerçek veya tüzel kişiyi, <b>TÜKETİCİ</b>: Ticari
        veya mesleki olmayan amaçlarla hareket eden gerçek veya tüzel kişiyi, <b>SİTE / PLATFORM</b>:
        https://studioai.incefikirler.tv/ adresinde faaliyet gösteren İnce Fikirler AI Studio
        platformunu, <b>SİPARİŞ</b>: ALICI'nın Site üzerinden oluşturduğu ve ödeme/onay aşamasını
        tamamladığı hizmet talebini, <b>TEKLİF</b>: Projenin kapsamını, hizmetleri, teslim süresini,
        revizyon haklarını ve bedelini gösteren elektronik teklif dokümanını, <b>TARAFLAR</b>: SAĞLAYICI
        ve ALICI'yı ifade eder.
      </p>

      <LegalH2>3. Sözleşmenin Konusu</LegalH2>
      <p>
        İşbu Sözleşmenin konusu; ALICI'nın SAĞLAYICI'ya ait Site üzerinden elektronik ortamda sipariş
        verdiği yapay zekâ destekli prodüksiyon, görsel içerik, video, reklam filmi, tanıtım filmi,
        senaryo, kurgu ve/veya ilgili diğer hizmetlerin satışı ve ifasına ilişkin olarak tarafların hak
        ve yükümlülüklerinin belirlenmesidir. ALICI'nın tüketici sıfatını taşıdığı işlemlerde 6502 sayılı
        Kanun, Mesafeli Sözleşmeler Yönetmeliği ve ilgili diğer mevzuat hükümleri uygulanır. Site veya
        ALICI'ya gönderilen teklif üzerinde belirtilen fiyat, kapsam, teslim süresi ve diğer proje
        koşulları siparişin ayrılmaz parçasıdır.
      </p>

      <LegalH2>4. Sağlayıcı Bilgileri</LegalH2>
      <p>
        Ad / Unvan: {COMPANY.owner} – İnce Fikirler Fotoğraf Prodüksiyon<br />
        Vergi Dairesi: Üsküdar Vergi Dairesi &nbsp;•&nbsp; Vergi No: {COMPANY.taxNo}<br />
        Adres: {COMPANY.address}<br />
        Telefon: {COMPANY.phone} &nbsp;•&nbsp; E-posta: {COMPANY.email}<br />
        Web: https://studioai.incefikirler.tv/
      </p>

      <LegalH2>5. Alıcı Bilgileri</LegalH2>
      <p>
        ALICI'ya ait; Ad / Soyad / Unvan, Adres, Telefon, E-posta, Vergi Dairesi / Vergi Numarası (varsa)
        ve Fatura Bilgileri sipariş sırasında ALICI tarafından sisteme girilen bilgilerden oluşur. ALICI,
        bildirdiği bilgilerin doğru ve güncel olduğunu kabul eder.
      </p>

      <LegalH2>6. Sipariş Veren Kişi Bilgileri</LegalH2>
      <p>
        Sipariş veren kişinin Ad / Soyad / Unvan, Adres, Telefon ve E-posta bilgileri sipariş
        oluşturulurken sistemde kayıt altına alınır. Siparişi bir şirket veya kuruluş adına veren kişi,
        söz konusu kuruluş adına sipariş vermeye yetkili olduğunu kabul ve beyan eder.
      </p>

      <LegalH2>7. Sözleşme Konusu Hizmetler ve Fiyat</LegalH2>
      <p>
        <b>7.1. Hizmetin Temel Özellikleri.</b> Hizmetin kapsamı proje bazında belirlenir ve şu
        unsurların birini veya birkaçını içerebilir: yapay zekâ destekli reklam/tanıtım filmi üretimi,
        senaryo geliştirme, storyboard oluşturma, yapay zekâ ile görsel/video üretimi, kurgu, montaj,
        seslendirme, müzik, renk düzenleme, grafik ve motion design çalışmaları ile proje teklifinde
        belirtilen diğer prodüksiyon hizmetleri. Hizmetin kesin kapsamı, ALICI tarafından onaylanan teklif
        ve sipariş özetinde belirtilir.
      </p>
      <p>
        <b>7.2. Fiyat.</b> Hizmet bedeli proje bazında belirlenir. ALICI'ya ödeme öncesinde hizmet
        kapsamı, toplam bedel, vergiler, varsa ek hizmet ücretleri ve ödeme planı açıkça gösterilir. Aksi
        teklif veya sipariş koşullarında belirtilmedikçe proje bedelinin %50'si ön ödeme, kalan %50'si
        teslim/onay aşamasında tahsil edilir.
      </p>
      <p>
        <b>7.3. Sipariş Özeti.</b> Proje Adı, Sipariş No, Hizmet Açıklaması, Hizmet Bedeli, KDV, Toplam
        Bedel, Ön Ödeme, Kalan Ödeme ve Tahmini Teslim Süresi sistem tarafından oluşturulur. Ödemeler Site
        üzerinde sunulan güvenli ödeme yöntemleri ve iyzico ödeme altyapısı üzerinden gerçekleştirilebilir.
      </p>

      <LegalH2>8. Fatura Bilgileri</LegalH2>
      <p>
        Fatura; ALICI tarafından sipariş sırasında bildirilen ad, soyad/unvan, adres, vergi dairesi, vergi
        numarası ve diğer fatura bilgileri kullanılarak düzenlenir. Mevzuatın izin verdiği durumlarda
        e-fatura veya e-arşiv fatura elektronik ortamda ALICI'nın bildirdiği e-posta adresine
        gönderilebilir. ALICI, fatura bilgilerinin doğruluğundan sorumludur.
      </p>

      <LegalH2>9. Genel Hükümler</LegalH2>
      <p>
        <b>9.1. Ön Bilgilendirme ve Kabul.</b> ALICI; hizmetin temel nitelikleri, toplam fiyatı, ödeme
        yöntemi, ifa şekli, tahmini teslim süresi, cayma hakkı ve cayma hakkının kullanılamayacağı
        durumlar hakkında sipariş öncesinde bilgilendirildiğini kabul eder. Siparişi elektronik ortamda
        onayladığında işbu Sözleşmeyi ve Ön Bilgilendirme Formu'nu okuyup kabul etmiş sayılır.
      </p>
      <p>
        <b>9.2. Hizmetin Başlaması.</b> Üretim süreci, gerekli ön ödemenin/sipariş bedelinin tahsil
        edilmesinden ve gerekli proje bilgilerinin ALICI tarafından iletilmesinden sonra başlar. ALICI'nın
        tüketici olması ve hizmetin 14 günlük cayma süresi dolmadan başlamasını istemesi halinde ayrıca
        açık onay alınır.
      </p>
      <p>
        <b>9.3. İfa ve Teslim Süresi.</b> Hizmet, onaylanan teklifte/sipariş özetinde belirtilen süre
        içerisinde tamamlanır. Teslim süresi; ALICI'nın gerekli bilgi, belge, logo, görsel, video, ürün
        fotoğrafı, marka materyali ve onayları zamanında sağlamasına bağlıdır. ALICI'dan kaynaklanan
        gecikmeler süreye eklenebilir. Mücbir sebep ve tarafların kontrolü dışındaki olaylarda ALICI
        bilgilendirilir.
      </p>
      <p>
        <b>9.4. Revizyonlar.</b> Revizyon sayısı ve kapsamı teklifte belirtilir. Onaylanan senaryo, brief
        veya yaratıcı yönün sonradan değiştirilmesi nedeniyle oluşacak ilave çalışmalar yeni hizmet olarak
        ayrıca ücretlendirilebilir. İlave ücret gerektiren işlem, ALICI'nın onayı alınmadan
        gerçekleştirilmez.
      </p>
      <p>
        <b>9.5. ALICI Tarafından Sağlanan Materyaller.</b> ALICI; ilettiği logo, marka, fotoğraf, video,
        müzik, metin, ürün görseli ve diğer materyalleri kullanmaya yetkili olduğunu kabul eder. Üçüncü
        kişilere ait materyallerin izin ve lisansları ALICI'nın sorumluluğundadır; SAĞLAYICI tarafından
        temin edilen üçüncü taraf lisanslarının kapsamı proje teklifinde belirtilir.
      </p>
      <p>
        <b>9.6. Yapay Zekâ Destekli Üretim.</b> ALICI, hizmetlerin tamamında veya bir bölümünde yapay zekâ
        destekli üretim teknolojilerinin kullanılabileceğini kabul eder. Yapay zekânın teknik niteliği
        nedeniyle görüntü, hareket, obje, karakter, ses veya diğer yaratıcı unsurlarda farklılıklar
        oluşabilir. SAĞLAYICI, teslim edilen çalışmanın onaylanan brief ve teklif kapsamına uygun
        hazırlanması için gerekli mesleki özeni gösterir.
      </p>

      <LegalH2>10. Cayma Hakkı</LegalH2>
      <p>
        ALICI'nın 6502 sayılı Kanun kapsamında tüketici olduğu durumlarda, hizmet sözleşmesinin kurulduğu
        tarihten itibaren 14 gün içerisinde, gerekçe göstermeksizin ve cezai şart ödemeksizin sözleşmeden
        cayma hakkı bulunmaktadır. Cayma bildiriminin 14 günlük süre içinde {COMPANY.email} adresine veya
        SAĞLAYICI'nın yukarıdaki açık adresine yazılı olarak ya da kalıcı veri saklayıcısı aracılığıyla
        gönderilmesi yeterlidir. Cayma hakkının usulüne uygun kullanılması halinde, bildirimin ulaştığı
        tarihten itibaren mevzuatta öngörülen süre içinde ilgili bedel, ALICI'nın kullandığı ödeme aracına
        uygun şekilde iade edilir.
      </p>

      <LegalH2>11. Cayma Hakkının Kullanılamayacağı Haller</LegalH2>
      <p>
        Mesafeli Sözleşmeler Yönetmeliğindeki istisnalar saklıdır. <b>11.1.</b> Cayma süresi sona ermeden
        ALICI'nın açık onayı ile ifasına başlanan hizmetlerde cayma hakkı kullanılamaz; ALICI'nın “14
        günlük cayma süresi dolmadan hizmetin ifasına başlanmasını talep ediyorum ve onaylıyorum; ifasına
        başlanması halinde cayma hakkımı kullanamayacağım konusunda bilgilendirildim.” şeklindeki açık
        onayı elektronik ortamda alınabilir ve kayıt altına alınabilir. <b>11.2.</b> Elektronik ortamda
        anında ifa edilen hizmetler veya anında teslim edilen gayrimaddi/dijital içeriklerde, mevzuattaki
        şartların oluşması halinde cayma hakkı kullanılamaz. <b>11.3.</b> Hizmetin ifasına başlanmadığı ve
        cayma hakkının mevzuat gereği devam ettiği durumlarda ALICI cayma hakkını kullanabilir.
        <b> 11.4.</b> ALICI'nın siparişi ticari/mesleki amaçlarla vermesi ve tüketici sıfatını taşımaması
        halinde iptal, değişiklik ve iade koşulları proje teklifi, sipariş koşulları ve taraflar arasındaki
        diğer sözleşmeler kapsamında değerlendirilir.
      </p>

      <LegalH2>12. Ödeme, Temerrüt ve İadeler</LegalH2>
      <p>
        ALICI, ödemeyi kredi kartı veya diğer ödeme araçlarıyla gerçekleştirmesi halinde ilgili banka/ödeme
        kuruluşu ile arasındaki sözleşme hükümlerinin ayrıca uygulanacağını kabul eder. Kartın/ödeme
        aracının ALICI'nın yetkisi dışında hukuka aykırı kullanımı halinde ilgili mevzuat ve prosedürler
        uygulanır. ALICI'nın ödeme yükümlülüklerini zamanında yerine getirmemesi halinde SAĞLAYICI projeyi
        durdurabilir ve teslimatı ödeme gerçekleşinceye kadar askıya alabilir. Mevzuattan doğan zorunlu
        iade hakları saklıdır.
      </p>

      <LegalH2>13. Uyuşmazlıklar ve Yetkili Merciler</LegalH2>
      <p>
        ALICI'nın tüketici sıfatını taşıdığı uyuşmazlıklarda, mevzuattaki parasal sınırlar dâhilinde
        ALICI'nın yerleşim yeri veya işlemin yapıldığı yerdeki Tüketici Hakem Heyetlerine veya Tüketici
        Mahkemelerine başvurulabilir. ALICI'nın ticari/mesleki amaçla hareket ettiği ve tüketici sıfatını
        taşımadığı işlemlerde ilgili genel ve ticari hukuk hükümleri uygulanır.
      </p>

      <LegalH2>14. Yürürlük ve Elektronik Onay</LegalH2>
      <p>
        ALICI; işbu Sözleşmeyi, Ön Bilgilendirme Formunu, hizmetin kapsamını, toplam bedeli, ödeme
        koşullarını, teslim süresini, cayma hakkını ve kullanılamayacağı durumları sipariş vermeden önce
        okuyup anladığını kabul eder. ALICI'nın Site üzerinden siparişi onaylaması ve ödemeyi
        gerçekleştirmesiyle işbu Sözleşme elektronik ortamda kurulmuş ve yürürlüğe girmiş olur.
        Sözleşmenin elektronik kayıtları, sipariş bilgileri, ödeme kayıtları ve elektronik onaylar
        yürürlükteki mevzuat çerçevesinde saklanır.
      </p>
      <p>
        <b>SAĞLAYICI:</b> {COMPANY.owner} – İnce Fikirler Fotoğraf Prodüksiyon<br />
        <b>ALICI:</b> Sipariş sırasında bildirilen kişi/kuruluş
      </p>
    </LegalPage>
  );
}
